import { combineReducers } from 'redux';
import { merge } from 'lodash';
import { handleActions } from 'redux-actions';
import * as taskTypes from './taskTypes';
import queryString from 'query-string';

const byId = handleActions(
  {
    [taskTypes.TASK_LIST.SUCCESS]: (state, { payload }) => merge({}, state, payload.entities.tasks),
  },
  {},
);

const allIds = handleActions(
  {
    [taskTypes.TASK_LIST.SUCCESS]: (state, { payload }) => [...new Set([...state, ...payload.result])],
  },
  [],
);

const byQueryIds = handleActions(
  {
    [taskTypes.TASK_LIST.SUCCESS]: (state, { payload, meta = {} }) => {
      const queryStr = queryString.stringify(meta);
      return {
        ...state,
        [queryStr]: Array.isArray(payload.result) ? payload.result : [payload.result],
      };
    },
  },
  {},
);

export default combineReducers({
  byId,
  list: combineReducers({
    allIds,
    byQueryIds,
  }),
});
